import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { AdminShell } from '../components/admin/AdminShell';
import { adminApi, apiError } from '../lib/adminApi';

export default function AdminResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 12) return setError('La contraseña debe tener al menos 12 caracteres.');
    if (password !== confirm) return setError('Las contraseñas no coinciden.');
    setBusy(true);
    try {
      await adminApi.post('/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AdminShell title="Panel de administración">
      <Card className="bg-white border-tan shadow-md">
        <CardContent className="p-6 md:p-8">
          <h1 className="text-xl font-bold text-cafe-noir mb-6">Establecer contraseña</h1>
          {done ? (
            <div data-testid="reset-success" className="space-y-4">
              <p className="text-kombu-green">Contraseña establecida correctamente.</p>
              <Link to="/admin/login" data-testid="reset-go-login" className="text-moss-green underline">Ir a iniciar sesión</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <Input data-testid="reset-password-input" type="password" required placeholder="Nueva contraseña (mín. 12 caracteres)"
                value={password} onChange={(e) => setPassword(e.target.value)} className="bg-white border-tan" />
              <Input data-testid="reset-confirm-input" type="password" required placeholder="Repite la contraseña"
                value={confirm} onChange={(e) => setConfirm(e.target.value)} className="bg-white border-tan" />
              {error && <p data-testid="reset-error" className="text-sm text-red-700">{error}</p>}
              <Button data-testid="reset-submit" type="submit" disabled={busy || !token}
                className="w-full bg-kombu-green hover:bg-kombu-green-dark text-white">
                {busy ? 'Guardando...' : 'Guardar contraseña'}
              </Button>
              {!token && <p className="text-sm text-red-700">Falta el enlace de seguridad. Solicita uno nuevo.</p>}
            </form>
          )}
        </CardContent>
      </Card>
    </AdminShell>
  );
}
